import styles from './ChatRow.module.css';

const ChatIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

export interface ChatRowProps {
  name: string;
  subtitle?: string | null;
  avatarUrl?: string | null;
  avatarFallback?: string;
  gradientAvatar?: boolean;
  onChat: () => void;
  testId?: string;
}

function cssUrl(url: string): string {
  return `url("${url.replace(/[\\"]/g, (character) => `\\${character}`)}")`;
}

export function ChatRow({
  name,
  subtitle,
  avatarUrl,
  avatarFallback,
  gradientAvatar = false,
  onChat,
  testId,
}: ChatRowProps) {
  return (
    <div className={styles.row} data-testid={testId}>
      <div
        className={[styles.avatar, gradientAvatar ? styles.gradientAvatar : ''].filter(Boolean).join(' ')}
        style={avatarUrl ? { backgroundImage: cssUrl(avatarUrl) } : undefined}
        aria-hidden="true"
      >
        {avatarUrl ? '' : avatarFallback}
      </div>
      <div className={styles.who}>
        <span className={styles.question}>Questions? Chat with</span>
        <span className={styles.name}>{name}</span>
        {subtitle && <span className={styles.line}>{subtitle}</span>}
      </div>
      <button type="button" className={styles.chat} onClick={onChat} aria-label={`Message ${name}`}>
        <ChatIcon />
      </button>
    </div>
  );
}
